import useRead from '../../useRead';

const useGetProductConcern = ({ concernId, onSuccess } = {}) => {
  const {
    data,
    paramsObject,
    setGetListParams,
  } = useRead({
    url: "concern/view",
    initialData: concernId ? { concern_id: concernId } : {},
    method: "GET",
    enabled: !!concernId,
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data);
      }
    },
  });

  return {
    data,
    paramsObject,
    setGetListParams,
  };
};

export default useGetProductConcern;
